module.exports = __webpack_public_path__ + "static/media/Group 64855.1e2f6f0e.svg";